import { parseCookies } from 'nookies';

import { CookiesName } from 'utils/constants';

export const isZmyleCookie = (
  value?: string | Record<string, any>,
): value is ZmyleCookie => {
  if (!value || (typeof value === 'object' && !('consents' in value))) {
    return false;
  }

  try {
    if (typeof value !== 'string') return false;

    const parsedCookie = JSON.parse(value);

    return Boolean('consents' in parsedCookie);
  } catch {
    return false;
  }
};

export const getZmyleCookie = (
  params?: Parameters<typeof parseCookies>[0],
): ZmyleCookie => {
  const cookies = parseCookies(params);

  const zmyleCookie = cookies[CookiesName.zmyleCookie];

  return isZmyleCookie(zmyleCookie)
    ? JSON.parse(zmyleCookie)
    : { consents: { marketing: [], media: [] } };
};
